<template>
  <div class="dishForm">
    <h3 class="dishForm__heading">
      Usuń danie z menu
    </h3>

    <form class="dishForm__form" onsubmit="return false">

      <justSelectForm class="justSelectForm--visible"
                      @fillForm="fillFormWithReceivedData">
      </justSelectForm>

      <input type="submit"
             value="Usuń"
             class="dishForm__form__button dishForm__form__button--visible remove"
             @click="removeExistingDish">

      <span class="dishForm__form__reply"
            :class="{'dishForm__form__reply--visible': replyMessageVisible}">
        Usuwanie dania odbyło się pomyślnie.
      </span>
    </form>
  </div>
</template>

<script>
import justSelectForm from './justSelectForm'
import { db } from '../../firebase'
import firebase from 'firebase'

export default {
  name: 'removeDishForm',
  components: { justSelectForm },
  data () {
    return {
      replyMessageVisible: false,
      dish: {},
    }
  },
  methods: {
    removeExistingDish () {
      let dishId = `dish${this.dish.id}`

      db.collection('dishes').doc(this.chooseTheRightCategory())
        .update({
          [dishId]: firebase.firestore.FieldValue.delete()
        })

      this.showReplyMessage();
      this.clearFormAfterAdding();
      this.hideReplyAfterTwoSeconds();
    },
    fillFormWithReceivedData (receivedData) {
      let chooseCategory = this.chooseTheRichCategoryFromReceivedData(receivedData.category);

      db.collection("dishes").doc(chooseCategory).get().then(doc => {
        let data = doc.data();

        for (let doc in data) {
          if (data[doc].name === receivedData.name) this.dish = data[doc]
        }
      })
    },
    chooseTheRichCategoryFromReceivedData(data) {
      if (data.includes(`kids`)) return `forKids`
      else if (data.includes(`alcohol-`)) return `alcohol`
      else return `normal`
    },
    chooseTheRightCategory () {
      if (this.dish.type.includes(`kids`)) return `forKids`
      else if (this.dish.type.includes(`alcohol-`)) return `alcohol`
      else return `normal`
    },
    showReplyMessage () {
      this.replyMessageVisible = true
    },
    clearFormAfterAdding () {
      for (let element in this.dish) {
        this.dish[element] = ''
      }
    },
    hideReplyAfterTwoSeconds () {
      setTimeout(() => {
        this.replyMessageVisible = false
      }, 2000)
    },
  }
}
</script>
